import { memo } from 'react';
import { ResponsiveModal } from '@bridebook/aura';
import { useMarket } from '@bridebook/web/app-shared/lib/i18n/hooks/use-market';
import { BackgroundStarsAnimation } from '@bridebook/web/components/bbcommon/animations/background-stars-animation';
import { useSelector } from '@bridebook/web/lib/utils';
import { lazyComponent } from '@bridebook/web/lib/utils/lazy/lazy-component';
import {
  getSupplierToBook,
  selectShowVenueConfirm,
} from '@bridebook/web/lib/venue-confirmation/selectors';
import GlobalVenueModalInfo from './shared/global-venue-modal-info';
import {
  useVenueConfirmationContext,
  VenueConfirmationContextProvider,
} from './venue-confirmation-context';

const VenueConfirmation = lazyComponent(
  () => import('@bridebook/web/components/venue-confirmation/venue-confirmation'),
);

const VenueConfirmationModalContent = () => {
  const { handleClose } = useVenueConfirmationContext();

  return (
    <ResponsiveModal className="overflow-hidden" isOpen onOpenChange={handleClose}>
      <BackgroundStarsAnimation />
      <VenueConfirmation />
    </ResponsiveModal>
  );
};

const VenueConfirmationModal = () => {
  const showVenueConfirm = useSelector(selectShowVenueConfirm);
  const supplierToBook = useSelector(getSupplierToBook);
  const { country } = useMarket();

  const showInfoDialog =
    showVenueConfirm &&
    supplierToBook &&
    !supplierToBook.customSupplier &&
    country !== supplierToBook?.countryCode;

  if (!showVenueConfirm) return null;

  if (showInfoDialog) {
    return <GlobalVenueModalInfo />;
  }

  return (
    <VenueConfirmationContextProvider>
      <VenueConfirmationModalContent />
    </VenueConfirmationContextProvider>
  );
};
export default memo(VenueConfirmationModal);
